
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/[slug]",
      function () {
        return require("private-next-pages/checkout/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/[slug]"])
      });
    }
  